import { createSlice } from '@reduxjs/toolkit';

import * as api from 'api/course';
import { search } from 'api/courseService';

type tagType = {
  category: Array<string>;
  content: Array<string>;
  total: number;
};
type searchFromType = {
  keyword: string;
  grade: Array<string>;
  type: Array<string>;
  tag: string;
};

type CourseState = {
  tag: tagType;
  searchFrom: searchFromType;
  isLoading: boolean;
  searchList: object;
  selectd: Array<any>;
};

const initialState: CourseState = {
  tag: {
    category: [],
    content: [],
    total: 0
  },
  searchFrom: {
    keyword: '',
    grade: [],
    type: [],
    tag: ''
  },
  isLoading: false,
  searchList: {},
  selectd: []
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      // state.error = action.payload;
    },

    getTagSuccess(state, { payload }) {
      const { rows, total } = payload;
      const category = rows.filter((menu: any) => !menu.parent_id);
      const content = rows.filter((menu: any) => !!menu && !!menu.parent_id);
      state.tag = { category, content, total };
    },
    getSearchListSuccess(state, { payload }) {
      state.isLoading = false;
      state.searchList = payload;
    },
    clearSearchList(state) {
      state.searchList = [];
    },
    getSearchFrom(state, { payload }) {
      state.searchFrom = { ...state.searchFrom, ...payload };
    },
    getSelectd(state, { payload }) {
      state.selectd = [...payload];
    },
    initAddCourse(state) {
      state.searchFrom = { ...initialState.searchFrom };
      state.searchList = {
        rows: [],
        total: 0
      };
    }
  }
});

// Actions
export const { getSearchFrom, getSelectd, initAddCourse } = slice.actions;

export function getTag() {
  return async (dispatch: Function) => {
    try {
      const response = await api.getTag();
      dispatch(slice.actions.getTagSuccess(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}
export function getSearchList(params: any) {
  return async (dispatch: Function) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await search(params);
      dispatch(slice.actions.getSearchListSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
